export default "__VITE_ASSET__ktCEI8kP__"